export const PRIVACY_POLICY_LINK = 'https://homefi.info/pages/privacy-policy';
export const TERMS_OF_SERVICE_LINK =
  'https://homefi.info/pages/terms-of-service-homefi';
export const RETURN_POLICY_LINK = 'https://homefi.info/pages/return-policy';
export const FEEDBACK_JOTFORM_LINK = `https://hello-support.jotform.com/241436910768967`;
export const CONTACT_US_JOTFORM = `https://hello-support.jotform.com/240286507893970?parentURL=https%3A%2F%2Fhomefi.gorgias.help%2Fen-US%2Farticles`;
